
import Typography from '@mui/material/Typography';


export const TextDrugEliglustat = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


Eliglustat is used to treat Gaucher disease type 1 (a condition in which a certain fatty substance is not broken down normally in the body and builds up 
in some organs and causes liver, spleen, bone, and blood problems) in certain people. Eliglustat is in a class of medications called enzyme inhibitors. 
It works by preventing the body from producing the fatty substance so that less of it will build up in the body and cause symptoms.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a618038.html

</Typography>

</div>

)
}